import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GoogleMap from 'google-map-react'
// import { fitBounds } from 'google-map-react/utils'
import LatLng from 'google-map-react/lib/utils/lib_geo/lat_lng.js'
import LatLngBounds from 'google-map-react/lib/utils/lib_geo/lat_lng_bounds.js'
import MainMarker from './MainMarker'
import MapMarker from './MapMarker'
import * as actions from '../../actions'
import { filteredProperties } from 'utils'

/*
 Google Maps component
*/
class Map extends Component {
  static propTypes = {
    properties: PropTypes.object.isRequired,
    onMarkerClick: PropTypes.func,
  }

  constructor(props) {
    const defZoom = parseInt(process.env.REACT_APP_DEFAULT_ZOOM, 10)
    super(props)
    this.state = {
      hoveredMarkerId: null,
      zoom: this.props.initialZoom ? this.props.initialZoom : defZoom,
      center: this.props.center,
      bounds: new LatLngBounds(),
      markers: [],
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.setState({
        hoveredMarkerId: nextProps.selected,
      })
    }
  }

  componentDidMount() {
    this.rebuildMarkers(this.props.properties)
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  propFlagged() {
    this.rebuildMarkers(this.props.properties)
  }

  rebuildMarkers(props) {
    let newBounds = new LatLngBounds()
    let properties = filteredProperties(props.valueSeq())
    properties.forEach((p, ix) => newBounds.extend(new LatLng(p.lat, p.lng)))

    this.setState(
      {
        markers: properties,
        bounds: newBounds,
      } /* update marker and bounds */
    )
    let stat = {
      center: { lat: newBounds.getCenter().lat, lng: newBounds.getCenter().lng },
    }
    this.setState(stat)
  }

  onBoundsChange = (zoom, bounds) => {
    let stat = {}
    // We've been updating the bounds when we rebuild the markers, so use that to update the
    // map bounds.
    if (bounds) {
      // const geoService = this.refs.map.geoService_
      // const fit = fitBounds(
      //   { nw: this.state.bounds.getNorthWest(), se: this.state.bounds.getSouthEast() },
      //   { width: geoService.getWidth(), height: geoService.getHeight() }
      // )
      stat = {
        center: { lat: this.state.bounds.getCenter().lat, lng: this.state.bounds.getCenter().lng },
        zoom: zoom.zoom,
      }
    }
    this.setState(stat)
  }

  setHoveredMarkerId(id = null) {
    const { actions, properties } = this.props
    let newProperties = filteredProperties(properties)
    let propId = id === null ? id : newProperties.size === 1 ? parseInt(newProperties.valueSeq().toArray()[0].id, 10) : id
    actions.mapMarkerHover(propId)
    this.setState({
      hoveredMarkerId: propId,
    })
  }

  render() {
    const { mobile, pageType, cachedPropertyMarkers } = this.props
    const { zoom, markers, center, bounds } = this.state
    const { hoveredMarkerId } = this.state
    const linkToBase = pageType === 'home' ? 'properties' : 'details'
    let zoomMap = isNaN(zoom) ? process.env.REACT_APP_DEFAULT_ZOOM : zoom
    const showPriceTag = zoomMap > process.env.REACT_APP_DEFAULT_ZOOM - 1
    const searchString = pageType === 'home' ? this.props.searchString : ''
    const createMapOptions = maps => {
      return {
        zoomControl: !mobile,
        minZoom: 7,
        maxZoom: 19,
        fullscreenControl: !mobile,
        fullscreen: !!mobile,
        gestureHandling: 'greedy',
        styles: [
          {
            stylers: [{ visibility: 'on' }, { saturation: -100 }, { gamma: 0.8 }, { lightness: 4 }],
          },
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }],
          },
        ],
      }
    }
    return (
      <GoogleMap
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_TOKEN }}
        options={createMapOptions}
        hoverDistance={30}
        center={center}
        zoom={zoomMap}
        ref="map"
        onChange={zoom => this.onBoundsChange(zoom, bounds)}
        onChildMouseEnter={id => this.setHoveredMarkerId(parseInt(id, 10))}
        onChildMouseLeave={() => this.setHoveredMarkerId(null)}>
        <MainMarker lat={center.lat} lng={center.lng} />
        {markers.map((p, ix) => (
          <MapMarker
            key={p.id}
            property={p}
            linkTo={`/${linkToBase}/${p.id}?${searchString}`}
            onMarkerClick={() => this.props.onMarkerClick()}
            lat={p.lat}
            lng={p.lng}
            hovered={hoveredMarkerId === parseInt(p.id, 10)}
            showPriceTag={showPriceTag}
          />
        ))}
        {cachedPropertyMarkers.valueSeq().map((p, ix) => (
          <MapMarker
            key={p.id}
            property={p}
            linkTo={`/${linkToBase}/${p.id}?${searchString}`}
            onMarkerClick={() => this.props.onMarkerClick()}
            lat={p.lat}
            lng={p.lng}
            hovered={hoveredMarkerId === parseInt(p.id, 10)}
            showPriceTag={showPriceTag}
          />
        ))}
      </GoogleMap>
    )
  }
}

Map.defaultProps = {
  clusterRadius: 60,
  hoverDistance: 30,
  options: {
    minZoom: 7,
    maxZoom: 15,
  },
  style: {
    position: 'relative',
    margin: 0,
    padding: 0,
    flex: 1,
  },
  center: {
    lat: parseFloat(process.env.REACT_APP_DEFAULT_LAT),
    lng: parseFloat(process.env.REACT_APP_DEFAULT_LNG),
  },
  zoom: 9,
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}
function mapStateToProps(state) {
  return {
    properties: state.properties.get('data'),
    cachedPropertyMarkers: state.cachedPropertyMarkers.get('data'),
    selected: state.properties.get('selected'),
    filters: state.filters,
    queryType: state.subdomain.data.record_type,
    mapZoom: state.map.get('zoom'),
  }
}

const map = connect(
  mapStateToProps,
  mapDispatchToProps
)(Map)

export default map



// WEBPACK FOOTER //
// ./src/components/map/MapFranchisee.js